<template>
    <div class="courseCatalogue">
        <h2>课程目录</h2>
        <p class="txt">点击目录可以进行学习</p>
        <div class="courseList" v-for="(item,index) in CourseCatalogue" :key="index">
            <div class="noCatalogue" v-if="item.Items == null">
                <div class="SublistCata" @click="beginStudy(item.CourseID,item.ID)">
                    <div class="titleTimeBox">
                        <h3>{{item.Title}}</h3>
                        <p class="mobileTime">{{item.Title}}{{'('+item.Duration+')'}}</p>  
                        <p class="time">时长: {{item.Duration}}</p>
                    </div>
                    <div class="tnpBox">
                        <p class="num">{{item.Score}}</p>
                        <p class="play"><img src="../../assets/img/detial_play.svg" /><span>播放</span></p>
                        <div class="progress-wrap" v-show="item.Progress != undefined && item.Progress != 0">
                            <p v-show="item.Progress >=90" style="background-image: linear-gradient(to top, #0061FE 100%, transparent 0%)"></p>
                            <p v-show="item.Progress <90" style="background-image: linear-gradient(to top, #0061FE 50%, transparent 50%)"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="haveCatalogue" v-else>
                <h3>{{item.Title}}</h3>
                <course-tree-list :items="item.Items"></course-tree-list>
            </div>
        </div>
    </div>
</template>

<script>
import common from '../../components/common'
import CourseTreeList from '../../components/CourseTreeList'
export default {
    data() {
        return {
            CourseCatalogue:[],  // 课程目录
            courseId:undefined,  // 课程id
            classID:0,  // 课件ID
            lessonList:[],  // 每个视频的状态
        }
    },
    components: {
        CourseTreeList
    },
    mounted(){
        // 获取课程id
        this.courseId = this.$route.query.courseId;
        if(this.courseId == undefined){
           this.courseId = sessionStorage.getItem('courseID');
        }

        this.$axios.all([this.getStudyStut(),this.getCourseCatalog()]).then(this.$axios.spread((res1, res2) => {
            // 课件学习状态
            if(res1.data.Status == 0){
                this.classID = res1.data.Data.ClassID;
                this.lessonList = res1.data.Data.Lessons;
            }else if(res1.data.Status != -2){
                this.$message({
                    message: res1.data.Data,
                    type: 'error',
                    duration: 3000
                });
            }
            // 课程目录
            if(res2.data.Status == 0){
                this.CourseCatalogue = res2.data.Data;
            }else if(res2.data.Status != -2){
                this.$message({
                    message: res2.data.Data,
                    type: 'error',
                    duration: 3000
                });
            }

            if(this.lessonList == undefined) return;
            // 获取视频进度
            this.catalogStut(this.CourseCatalogue,this.lessonList);
        }));

        // 触发目录组件的点击事件
        this.cataBeginStudy();
    },
    methods:{
        // 获取视频进度状态
        catalogStut(item,append){
            item.forEach(item => {
                    append.forEach(a => {
                        if(item.ID === a.VideoID){
                            // vue如果要给一个对象里没有的键值赋值，就要用this.$set来赋值才能被监听到
                            this.$set(item, 'Progress', a.Process)
                        }
                    }) 
                    if(item.Items){
                        this.catalogStut(item.Items,append)
                    }
                })
           
        },
        // 获取目录
        getCourseCatalog(){
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId
            }
            return this.$axios.post(Const_Api_Root+'api/Course/Catalog',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            });
        },
        // 课件学习状态
        getStudyStut(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId,
                "Flag":1
            }
            return this.$axios.post(Const_Api_Root+'api/Course/MyClass',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            });
        },
        // 进入播放视频页面
        beginStudy(courseId,id){
            // 未学习过
            if(this.classID == 0){
                this.creatNewCourseware(id);
            }else if(this.classID > 0){
            // 正在学习中+已完成学习
                this.$router.push({
                    path: '/playVideo',
                    query: {
                        courseId:courseId,
                        id:id
                    }
                });
            }
        },
        // 创建新课件
        creatNewCourseware(id){ 
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId,
                "SecSplit":30
            }
            this.$axios.post(Const_Api_Root+'api/Course/CreateClass',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    // 跳转
                    this.$router.push({
                        path: '/playVideo',
                        query: {
                            courseId:this.courseId,
                            id:id
                        }
                    });
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 目录组件的点击事件
        cataBeginStudy(){
            common.$on('toVideoPlay',(courseId,id)=>{this.beginStudy(courseId,id)});
        }
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .courseCatalogue{
        width: 100%;
        .titleTimeBox{
            .time,h3{
                display: none;
            }
        }
        h2,.txt{
            display: none;
        }
        .courseList{
            width: 100%;
            h3{
                font-size: 12px;
                color: #19191A;
                font-weight: bold;
            }
        }
    }
    .haveCatalogue h3{
        padding: 15px 0 15px 20px;
        border-bottom: 2px solid #fafafa; 
    }
    .noCatalogue{
        width: 100%;
        .titleTimeBox{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .mobileTime{
            font-weight: bold;
        }
        .SublistCata{
            width: 100%;
            padding: 15px 0 15px 20px;
            font-size: 12px;
            color: #19191A;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 2px solid #fafafa;
            .tnpBox{
                font-size: 14px;
                display: flex;
                .play{
                    display: none;
                }
                .num{
                    margin-right: 5px;
                }
            }
        }
    }
    // 进度
    .progress-wrap{
        p{
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #0061FE;
            background-color: #fff; /* 浏览器不支持的时候显示 */
        }
    }
}
@media screen and (min-width: 1445px) {
    .courseCatalogue{
        width: 1200px;
        margin: 0 auto 72px;
        h2{
            font-size: 30px;
            color: #19191A;
            letter-spacing: 0;
            text-align: center;
        }
        .txt{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            letter-spacing: 0;
            text-align: center;
            margin: 20px 0 30px;
        }
        .courseList{
            width: 100%;
            h3{
                font-size: 16px;
                color: #19191A;
            }
        }
    }
    .titleTimeBox{
        width: 68.5%;
        .mobileTime{
            display: none;
        }
    }
    .haveCatalogue h3{
        padding: 15px 0;
        border-bottom: 2px solid #fafafa; 
    }
    .noCatalogue{
        width: 100%;
        .titleTimeBox{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .SublistCata{
            font-size: 14px;
            color: #19191A;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 17px 15px 0;
            border-bottom: 2px solid #fafafa;
            cursor: pointer;
            &:hover{
                background: #FAFAFA;
            }
            &:hover .play{
                display: flex;
            }
            &:hover .progress-wrap{
                display: none;
            }
            .tnpBox{
                width: 19%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                position: relative;
            }
            .play{
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);

                display: none;
                align-items: center;
                font-size: 14px;
                color: #0061FE;
                cursor: pointer;
                img{
                    width: 25px;
                    height: 25px;
                }
            }
        }
    }
    // 进度
    .progress-wrap{
        p{
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #0061FE;
            background-color: #fff; /* 浏览器不支持的时候显示 */
        }
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .courseCatalogue{
        width: 1100px;
        margin: 0 auto 72px;
        h2{
            font-size: 30px;
            color: #19191A;
            letter-spacing: 0;
            text-align: center;
        }
        .txt{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            letter-spacing: 0;
            text-align: center;
            margin: 20px 0 30px;
        }
        .courseList{
            width: 100%;
            h3{
                font-size: 16px;
                color: #19191A;
            }
        }
    }
    .titleTimeBox{
        width: 69.5%;
        .mobileTime{
            display: none;
        }
    }
    .haveCatalogue h3{
        padding: 15px 0;
        border-bottom: 2px solid #fafafa; 
    }
    .noCatalogue{
        width: 100%;
        .titleTimeBox{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .SublistCata{
            font-size: 14px;
            color: #19191A;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 17px 15px 0;
            border-bottom: 2px solid #fafafa;
            cursor: pointer;
            &:hover{
                background: #FAFAFA;
            }
            &:hover .play{
                display: flex;
            }
            &:hover .progress-wrap{
                display: none;
            }
            .tnpBox{
                width: 19%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                
                position: relative;
            }
            .play{
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);

                display: none;
                align-items: center;
                font-size: 14px;
                color: #0061FE;
                cursor: pointer;
                img{
                    width: 25px;
                    height: 25px;
                }
            }
        }
    }
    // 进度
    .progress-wrap{
        p{
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #0061FE;
            background-color: #fff; /* 浏览器不支持的时候显示 */
        }
    }
}
// 公用
ul li{
    border-bottom: 2px solid #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/pages/class/CourseCatalogue.vue